<template>
    <el-dialog v-model="visible" width="30%" top="50%" :appendToBody="appendToBody" :close-on-click-modal="false" :close-on-press-escape="false" @closed="closed" :modal="false" :show-close="false">
        <div class="export">
            <div class="export-title">
                <span>导出中</span>
                <span>{{ percentage }}%</span>
            </div>
            <div class="export-progress">
                <el-progress :percentage="percentage" color="#4e86ff" :show-text="false" :stroke-width="10"></el-progress>
            </div>
        </div>
    </el-dialog>
</template>

<script>
export default {
    // 组件名称
    name: 'exportProgress',
    // 组件参数 接收来自父组件的数据
    props: {
        isView: {
            type: Boolean,
            default: false
        },
        isClose: {
            type: Boolean,
            default: false
        },
        appendToBody: {
            type: Boolean,
            default: false
        }
    },
    // 局部注册的组件
    components: {},
    // 组件状态值
    data() {
        return {
            visible: false,
            percentage: 0,
            timer: null
        }
    },
    // 计算属性
    computed: {},
    // 侦听器
    watch: {
        isView: {
            immediate: true,
            handler(val) {
                if (val) {
                    this.visible = true
                }
            }
        },
        visible: {
            immediate: true,
            handler(val) {
                if (!val) {
                    clearInterval(this.timer)
                    this.timer = null
                    this.$emit('update:isView', false)
                }
            }
        },
        isClose: {
            immediate: true,
            handler(val) {
                if (val) {
                    this.percentage = 100
                    this.visible = false
                }
            }
        }
    },
    mounted() {
        this.timer = setInterval(() => {
            if (this.percentage === 100) return
            this.percentage++
        },1000)  
    },
    // 组件方法
    methods: {
        closed() {
            this.percentage = 0
            this.$emit('closed')
        }
    },
}
</script> 

<style scoped lang="scss">
::v-deep .el-dialog__header {
     padding: 0;
 }

 ::v-deep .el-dialog__body {
    padding: 30px 40px;
    .export {
        display: flex;
        flex-direction: column;
        align-items: start;
        &-progress {
            width: 100%;
            margin-top: 16px;
        }
        &-title {
            display: flex;
            width: 100%;
            justify-content: space-between;
        }
    }
 }

 ::v-deep .el-dialog {
    position: absolute;
    left: 50%;
    top: 50%;
    margin: 0 !important;
    transform: translate(-50%, -50%);
 }
</style>
